/* eslint-disable @typescript-eslint/no-unused-vars */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GET, RebirthHttp, Query } from 'rebirth-http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class AccountActivationService extends RebirthHttp {
  constructor(http: HttpClient) {
    super(http);
  }

  @GET(
    environment.wso2amEndPoint +
      environment.identityServerName +
      environment.wso2amApiVersion +
      '/public/v1/auth/active'
  )
  activate(
    @Query('token') token: string,
    @Query('username') username: string
  ): Observable<any> | any {
    return null; // leave `return null` due to TypeScript Interface isn't visable in runtime
  }
}
